module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.linkClasses
  }, [(_vm.href === '' || !_vm.href) ? _c('div', [_vm._t("default"), _vm._v(" "), (!_vm.showSeparator) ? _c('span', {
    class: _vm.separatorClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.separator)
    }
  }) : _vm._e()], 2) : _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.$_onClick
    }
  }, [_vm._t("default"), _vm._v(" "), (!_vm.showSeparator) ? _c('span', {
    class: _vm.separatorClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.separator)
    }
  }) : _c('span', {
    class: _vm.separatorClasses
  }, [_vm._t("separator")], 2)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-688c9e66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb/breadcrumb-item.vue
// module id = 380
// module chunks = 0